<template>
  <div class="d-flex justify-center">
    <img :src="imageUrl" style="width: 750px; max-width: 94vw;">
  </div>
</template>

<script setup lang="ts">
import { useEventsStore } from "@/stores/events";
import { computed } from "vue";

defineOptions({ name: "TEventMap" });

const eventsStore = useEventsStore();

const event = computed(() => eventsStore.selected!);

const imageUrl = computed<string>(() => {
  const image = event.value.images?.find(img => img.tag === "mapping-thumb");

  if (image) return image.url;

  return `https://office.ingressodevantagens.com.br/evento/${event.value.id}/imagemEstadio`;
});
</script>
